import React, { useContext, useState } from 'react'
import { MyContext } from '../App';
import Project from './Project';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function Projects() {
    const { Lang } = useContext(MyContext);
    const [projectType, setProjectType] = useState("web")
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

    const data = [
        {
            id: 1,
            type: "desktop",
            date: {
                Eng: "October 2022",
                Fr: "Octobre 2022",
                Ar: "أكتوبر ٢٠٢٢"
            },
            title: {
                Eng: "SchoolPro  — Streamline Your School Management with Ease",
                Fr: "SchoolPro  — Optimisez la gestion de votre établissement scolaire en toute simplicité",
                Ar: "SchoolPro - سهل إدارة مدرستك بسلاسة"
            },
            image: "https://drive.google.com/thumbnail?id=1NAvzZMIiRArRyI9eBSmk2HxccYbewvOS&sz=w1000",
            description: {
                Eng: "SchoolPro is a robust desktop-based school management system specifically designed to simplify and streamline data management for educational institutions. This comprehensive software provides schools with a centralized platform to store, organize, and access various types of data, ranging from student records and staff information to timetable management.",
                Fr: "SchoolPro est un système de gestion scolaire complet basé sur bureau spécialement conçu pour simplifier et rationaliser la gestion des données dans les établissements éducatifs. Ce logiciel exhaustif offre aux écoles une plateforme centralisée pour stocker, organiser et accéder à divers types de données, allant des dossiers des élèves aux informations sur le personnel en passant par la gestion des emplois du temps.",
                Ar: "مدرستي برو هو نظام إدارة المدارس القوي الذي يعتمد على سطح المكتب مصمم خصيصًا لتبسيط وتيسير إدارة البيانات للمؤسسات التعليمية. يوفر هذا البرنامج الشامل للمدارس منصة مركزية لتخزين وتنظيم والوصول إلى أنواع مختلفة من البيانات، تتراوح من سجلات الطلاب ومعلومات الموظفين إلى إدارة الجداول الزمنية."
            },
            tools: [
                "Electron.JS",
                "MySql",
                "JavaScript",
                "Ajax",
                "Php",
                "Tailwind CSS",
            ],
            sourceCodeLink: "https://github.com/Hakimhizmi/School_Management_System",
        },
        {
            id: 2,
            type: "web",
            date: {
                Eng: "March 2023",
                Fr: "Mars 2023",
                Ar: "مارس ٢٠٢٣"
            },
            title: {
                Eng: "KarylineHR — Empowering Effective Employee Management for Karyline company",
                Fr: "KarylineHR — Renforçant la gestion efficace des employés pour l'entreprise Karyline",
                Ar: "KarylineHR - تمكين إدارة الموظفين الفعالة لشركة كاريلين"
            },
            image: "https://drive.google.com/thumbnail?id=1N7suSyyFmfLdeV3p3lpOFHJMSjNcOPdx&sz=w1000",
            description: {
                Eng: "KarylineHR is a dedicated web-based solution specifically designed for Karyline, empowering efficient and streamlined employee management within the organization. With KarylineHR, you can seamlessly oversee various aspects of your workforce, including goal management, staff salaries, and time off, all within a user-friendly interface tailored to meet Karyline's specific requirements.",
                Fr: "KarylineHR est une solution web dédiée spécialement conçue pour Karyline, permettant une gestion efficace et rationalisée des employés au sein de l'organisation. Avec KarylineHR, vous pouvez superviser de manière transparente différents aspects de votre effectif, notamment la gestion des objectifs, les salaires du personnel et les congés, le tout au sein d'une interface conviviale adaptée aux besoins spécifiques de Karyline.",
                Ar: "كاريلين إتش آر هو حلاً ويب مخصص مصمم خصيصًا لكاريلين، يمكنك من خلاله تمكين إدارة الموظفين بكفاءة وبدون عناء داخل المنظمة. مع كاريلين إتش آر، يمكنك الإشراف بسهولة على مختلف جوانب قوة العمل الخاصة بك، بما في ذلك إدارة الأهداف ورواتب الموظفين والإجازات، كل ذلك داخل واجهة مستخدم سهلة الاستخدام مصممة لتلبية متطلبات كاريلين الخاصة."
            },
            tools: [
                "Laravel",
                "MySql",
                "React.js",
                "Tailwind CSS",
            ],
            sourceCodeLink: "https://github.com/Hakimhizmi/KARYLINEHR",
        },
        {
            id: 3,
            type: "web",
            date: {
                Eng: "May 2023",
                Fr: "Mai 2023",
                Ar: "مايو ٢٠٢٣"
            },
            title: {
                Eng: "My Apartement — Your Premier Apartment Marketplace",
                Fr: "My Apartement — Votre marché immobilier d'appartements de premier choix",
                Ar: "My Apartement — سوق الشقق الرئيسي الخاص بك"
            },
            image: "https://drive.google.com/thumbnail?id=1N5zf6vXOesFOreBf7ncfP5cS00fywHo7&sz=w1000",
            description: {
                Eng: "Welcome to My Apartment, your one-stop destination for online apartment shopping. Our platform is built on a combination of powerful technologies, including Tailwind and Laravel to deliver a seamless shopping experience.",
                Fr: "Bienvenue sur My Apartment, votre destination unique pour faire vos achats d'appartements en ligne. Notre plateforme repose sur une combinaison de technologies puissantes, notamment Tailwind et Laravel, pour vous offrir une expérience d'achat fluide.",
                Ar: "مرحبًا بك في بيتي، وجهتك الواحدة للتسوق عبر الإنترنت للشقق. تم بناء منصتنا على مجموعة من التقنيات القوية، بما في ذلك تيلويند ولارافيل، لتوفير تجربة تسوق سلسة."
            },
            tools: [
                "Laravel",
                "MySql",
                "Tailwind.CSS",
                "Laravel.authentication",
            ],
            sourceCodeLink: "https://github.com/Hakimhizmi/MyApartement.git",
        }, {
            id: 4,
            type: "web",
            date: {
                Eng: "August 2023",
                Fr: "Août 2023",
                Ar: "أغسطس ٢٠٢٣"
            },
            title: {
                Eng: "AutoGo — Car Rental Management System",
                Fr: "AutoGo — Système de gestion de location de voitures",
                Ar: "AutoGo - نظام إدارة تأجير السيارات"
            },
            image: "https://drive.google.com/thumbnail?id=1NFjDlrrlT2vgT3qHW27OFYB8-O0MPytL&sz=w1000",
            description: {
                Eng: `In this project, I have developed a comprehensive Car Rental Management System that facilitates seamless car rental services for customers while empowering administrators with efficient order management and communication tools. The system is designed to be user-friendly, ensuring a smooth experience for both clients and administrators.`,
                Fr: `Dans ce projet, j'ai développé un système complet de gestion de location de voitures, qui facilite les services de location de voitures sans heurts pour les clients tout en fournissant aux administrateurs des outils efficaces de gestion des commandes et de communication. Le système est conçu pour être convivial, garantissant une expérience fluide aussi bien pour les clients que pour les administrateurs.`,
                Ar: `في هذا المشروع، قمت بتطوير نظام شامل لإدارة تأجير السيارات يسهل خدمات تأجير السيارات بسلاسة للعملاء مع تمكين المسؤولين بأدوات فعالة لإدارة الطلبات والتواصل. تم تصميم النظام ليكون سهل الاستخدام، مما يضمن تجربة سلسة للعملاء والمسؤولين على حد سواء.`
            },
            tools: [
                "Laravel",
                "MySql",
                "React.Js",
                "Tailwind.CSS",
                "Stripe.Components",
            ],
            sourceCodeLink: "https://github.com/Hakimhizmi/AutoGo",
        }, {
            id: 5,
            type: "web",
            date: {
                Eng: "October 2023",
                Fr: "Octobre 2023",
                Ar: "أكتوبر ٢٠٢٣"
            },
            title: {
                Eng: "ExploreLocal — Discover the best places",
                Fr: "ExploreLocal — Découvrir les meilleurs endroits",
                Ar: "ExploreLocal - اكتشف أفضل الأماكن"
            },
            image: "https://drive.google.com/thumbnail?id=1NK-Aed4eGTpQ3tBYDleaDcrRm3cDAaJx&sz=w1000",
            description: {
                Eng: `At ExploreLocal, our mission is clear: to link you with the finest establishments and experiences in your vicinity. We firmly believe that the soul of any community resides within its local businesses, and our purpose is to facilitate your exploration of them. Whether you're a local resident in search of your next favorite spot or a traveler in pursuit of genuine encounters, we've got your interests covered.`,
                Fr: `Chez ExploreLocal, notre mission est claire : vous mettre en lien avec les meilleures entreprises et expériences de votre région. Nous croyons fermement que l'âme de toute communauté réside dans ses entreprises locales, et notre objectif est de faciliter votre exploration de celles-ci. Que vous soyez un résident local à la recherche de votre prochain endroit préféré ou un voyageur en quête de rencontres authentiques, nous couvrons vos intérêts.`,
                Ar: `في استكشاف المحلي، مهمتنا واضحة: ربطك بأفضل المؤسسات والتجارب في محيطك. نؤمن بثقة بأن روح أي مجتمع تكمن في شركاته المحلية، وغرضنا هو تسهيل استكشافك لها. سواء كنت مقيمًا محليًا تبحث عن مكانك المفضل التالي أو مسافرًا تسعى للقاءات حقيقية، لدينا ما تبحث عنه.`
            },
            tools: [
                "Python",
                "Flask",
                "Sqlite3",
                "Html",
                "Css",
                "Tailwind.CSS",
                "Js/Jquery",
            ],
            sourceCodeLink: "https://github.com/Hakimhizmi/Explore-Local-CS50",
        },
        {
            id: 6,
            type: "web",
            date: {
                Eng: "November 2023",
                Fr: "Novembre 2023",
                Ar: "نوفمبر ٢٠٢٣"
            },
            title: {
                Eng: "EcomOps beta — Orders Confirmation System",
                Fr: "EcomOps beta — Système de Confirmation des Commandes",
                Ar: "EcomOps beta - نظام تأكيد الطلبات"
            },
            image: "https://drive.google.com/thumbnail?id=1NSLs3zFNZQ1JiY5yQ0JyBHEDVO8r6ywL&sz=w1000",
            description: {
                Eng: `The E-commerce Order Confirmation System is a powerful web application designed to efficiently manage the complete order confirmation process in an e-commerce environment. It includes four specific user roles: Super Admin, Admin, Confirmer, and Delivery User. Providing a holistic solution for the entire order confirmation journey, the system stands out with its user-friendly interface, robust functionalities, and seamless integration capabilities. Engineered to streamline e-commerce operations, it guarantees a seamless experience for users in various roles, thereby improving the overall efficiency and effectiveness of the order management workflow.`,
                Fr: `Le système de confirmation des commandes en ligne (E-commerce) est une puissante application web conçue pour gérer efficacement l'ensemble du processus de confirmation des commandes dans un environnement de commerce électronique. Il comprend quatre rôles spécifiques d'utilisateurs : Super Admin, Admin, Confirmer et Utilisateur de Livraison. Offrant une solution holistique pour l'ensemble du parcours de confirmation des commandes, le système se distingue par son interface conviviale, ses fonctionnalités robustes et ses capacités d'intégration transparente. Conçu pour rationaliser les opérations de commerce électronique, il garantit une expérience sans heurts pour les utilisateurs dans divers rôles, améliorant ainsi l'efficacité globale et l'efficacité du flux de travail de gestion des commandes.`,
                Ar: `نظام تأكيد الطلبات الإلكترونية هو تطبيق ويب قوي مصمم لإدارة بشكل فعال عملية تأكيد الطلبات الكاملة في بيئة التجارة الإلكترونية. يشمل أربعة أدوار مستخدم محددة: مدير عام، مشرف، مؤكد، ومستخدم توصيل. من خلال تقديم حلاً شاملاً لرحلة تأكيد الطلبات بأكملها، يتميز النظام بواجهة مستخدم سهلة الاستخدام، ووظائفه القوية، وقدرات التكامل السلسة. مصمم لتبسيط عمليات التجارة الإلكترونية، يضمن تجربة سلسة للمستخدمين في مختلف الأدوار، مما يحسن من كفاءة وفاعلية إدارة الطلبات بشكل عام.`
            },
            tools: [
                "React.Js",
                "Tailwind.CSS",
                "Node.Js Express",
                "Mongodb",
            ]
        },
        {
            id: 7,
            type: "web",
            date: {
                Eng: "January 2024",
                Fr: "Janvier 2024",
                Ar: "يناير ٢٠٢٤"
            },
            title: {
                Eng: "EcomOps.sys — Subscription Management System",
                Fr: "EcomOps.sys — Système de Gestion des Abonnements",
                Ar: "EcomOps.sys - نظام إدارة الاشتراكات"
            },
            image: "https://drive.google.com/thumbnail?id=1NV5HXZ1uHf5SVxuRIRS1Xc9ki0T8V3Yg&sz=w1000",
            description: {
                Eng: `The Subscription Management System enhances the functionality of the E-commerce Order Confirmation System by providing a specialized solution for overseeing subscriptions. It includes features such as comprehensive statistics, user administration, real-time communication, and notification functions. This system ensures not only a streamlined subscription process but also contributes to the overall efficiency of the e-commerce ecosystem.`,
                Fr: `Le système de gestion des abonnements améliore la fonctionnalité du système de confirmation des commandes en ligne en fournissant une solution spécialisée pour superviser les abonnements. Il comprend des fonctionnalités telles que des statistiques complètes, l'administration des utilisateurs, la communication en temps réel et des fonctions de notification. Ce système garantit non seulement un processus d'abonnement rationalisé, mais contribue également à l'efficacité globale de l'écosystème de commerce électronique.`,
                Ar: `يعزز نظام إدارة الاشتراكات وظائف نظام تأكيد الطلبات الإلكتروني عن طريق توفير حلاً متخصصًا للإشراف على الاشتراكات. يشمل ميزات مثل الإحصائيات الشاملة وإدارة المستخدمين والاتصال في الوقت الفعلي ووظائف الإشعارات. يضمن هذا النظام ليس فقط عملية اشتراك مبسطة، ولكن أيضًا يساهم في الكفاءة الشاملة للنظام البيئي للتجارة الإلكترونية.`
            },
            tools: [
                "React.Js",
                "Tailwind.CSS",
                "Node.Js Express",
                "Mongodb",
            ]
        },
        {
            id: 8,
            type: "mobile",
            date: {
                Eng: "March 2024",
                Fr: "Mars 2024",
                Ar: "مارس ٢٠٢٤"
            },
            title: {
                Eng: "MyDirhams — Your Personal Expense Tracker",
                Fr: "MyDirhams — Votre suivi personnel des dépenses",
                Ar: "MyDirhams — متعقب المصاريف الشخصي الخاص بك"
            },
            image: "https://drive.google.com/thumbnail?id=1Nb09PtBJLm3oHZEwX5FFDtQtbwhjjo74&sz=w1000",
            description: {
                Eng: `MyDirhams is a bilingual (English and Arabic) mobile app designed for effortless expense tracking. With a focus on privacy, the app stores all your financial data offline on your device, ensuring accessibility without a constant internet connection. Its intuitive interface allows you to seamlessly add, delete, and categorize expenses, providing valuable insights into your spending patterns. MyDirhams empowers users with personalized settings, secure authentication, and cross-platform compatibility, making it the go-to companion for convenient and private financial management. Experience financial empowerment with MyDirhams, your trusted expense tracking solution.`,
                Fr: `MyDirhams est une application mobile bilingue (anglais et arabe) conçue pour un suivi sans effort des dépenses. Axée sur la confidentialité, l'application stocke toutes vos données financières hors ligne sur votre appareil, assurant une accessibilité sans connexion internet constante. Son interface intuitive vous permet d'ajouter, de supprimer et de catégoriser vos dépenses de manière transparente, offrant des informations précieuses sur vos habitudes de dépenses. MyDirhams donne aux utilisateurs un pouvoir accru grâce à des paramètres personnalisés, une authentification sécurisée et une compatibilité interplateforme, en faisant le compagnon idéal pour une gestion financière pratique et privée. Vivez une autonomie financière avec MyDirhams, votre solution de suivi des dépenses de confiance.`,
                Ar: `ديرهامز هو تطبيق محمول ثنائي اللغة (الإنجليزية والعربية) مصمم لتتبع المصاريف بسهولة. مع التركيز على الخصوصية، يقوم التطبيق بتخزين جميع بياناتك المالية دون اتصال بالإنترنت على جهازك، مما يضمن إمكانية الوصول دون اتصال إنترنت مستمر. تسمح واجهته البسيطة بإضافة وحذف وتصنيف المصاريف بسهولة، مما يوفر رؤى قيمة حول أنماط الإنفاق الخاصة بك. يمنح ديرهامز المستخدمين إعدادات شخصية ومصادقة آمنة وتوافقًا متعدد المنصات، مما يجعله الرفيق المثالي لإدارة مالية مريحة وخاصة. احصل على القدرة المالية مع ديرهامز، حل التتبع الموثوق به للمصاريف.`
            },
            tools: [
                "React Native",
                "Expo",
                "Async Storage",
                "Redux",
                "React Navigation"
            ],
            sourceCodeLink: "https://github.com/Hakimhizmi/MyDirhams.git",
            liveLink: "https://drive.google.com/file/d/1ISiUbBzxkAtJOZ38NMc53zpBig2b0F6C/view",
        },
    ];

    return (
        <div id='projects' ref={ref} className="py-10 px-6 md:px-20 bg-gradient-to-b from-black/30 to-black/80 overflow-hidden" >
            <div className="flex justify-between items-center">
                <div className="flex flex-col md:flex-row gap-2 md:gap-14 md:items-center">
                    <motion.div initial={{ x: -100, opacity: 0 }}
                        animate={inView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
                        transition={{ duration: 0.1, delay: 0.1 }} className="text-sm italic font-medium uppercase text-white/70 whitespace-nowrap">
                        {Lang === 'Ar' ? 'مشاريعي' : (Lang === 'Fr' ? 'mes projets' : 'my projects')}
                    </motion.div>
                    <motion.div initial={{ opacity: 0 }}
                        animate={inView ? { opacity: 1 } : { opacity: 0 }}
                        transition={{ duration: 0.3, delay: 0.3 }} className="text-md md:text-xl italic font-medium uppercase text-white/90 md:pr-8">
                        {Lang === 'Ar' ? 'بعض من أحدث أعمالي • يشمل منصات وسيناريوهات مختلفة، مما يظهر مرونتي وقدرتي على التكيف مع متطلبات العملاء'
                            : (Lang === 'Fr' ? 'QUELQUES-UNS DE MES TRAVAUX RÉCENTS • ENCOMPASSE DIVERSES PLATEFORMES ET SCÉNARIOS, DÉMONTRANT MA FLEXIBILITÉ ET MON ADAPTABILITÉ AUX EXIGENCES DES CLIENTS'
                                : 'SOME OF MY RECENT WORK • ENCOMPASSES VARIOUS PLATFORMS AND SCENARIOS, DEMONSTRATING MY FLEXIBILITY AND ADAPTABILITY TO CLIENT REQUIREMENTS')}
                    </motion.div>
                </div>
                <motion.div initial={{ x: 100, opacity: 0 }}
                    animate={inView ? { x: 0, opacity: 1 } : { x: 100, opacity: 0 }}
                    transition={{ duration: 0.3, delay: 0.3 }} className="text-sm italic font-medium text-white/90 whitespace-nowrap">
                    {Lang === 'Ar' ? '٢٠٢٢-٢٠٢٤' : (Lang === 'Fr' ? '2022-2024' : '2022-2024')}
                </motion.div>
            </div>
            <div className='mt-10 flex gap-6 md:gap-14 items-center justify-center'>
                <motion.div initial={{ scale: 0, opacity: 0 }}
                    animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
                    transition={{ duration: 0.2, delay: 0.2 }} onClick={() => setProjectType('web')} className={`text-md md:text-lg font-bold uppercase hover:text-white CosiAzureFont 
                ${projectType === "web" ? 'text-white underline' : ' text-white/70'} underline-offset-8 transition-all duration-500`}>
                    {Lang === 'Ar' ? 'المواقع الويب' : (Lang === 'Fr' ? 'Site Web' : 'Web')}
                    <span className='text-xs ml-2 inline-flex'>({data.filter(project => project.type === "web").length})</span>
                </motion.div>
                <motion.div initial={{ scale: 0, opacity: 0 }}
                    animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
                    transition={{ duration: 0.3, delay: 0.3 }} onClick={() => setProjectType('mobile')} className={`text-md md:text-lg font-bold uppercase hover:text-white CosiAzureFont
                 ${projectType === "mobile" ? 'text-white underline' : ' text-white/70'} underline-offset-8 transition-all duration-500`}>
                    {Lang === 'Ar' ? 'تطبيقات الهواتف المحمولة' : (Lang === 'Fr' ? 'Application Mobile' : 'Mobile App')}
                    <span className='text-xs ml-2 inline-flex'>({data.filter(project => project.type === "mobile").length})</span>
                </motion.div>
                <motion.div initial={{ scale: 0, opacity: 0 }}
                    animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 }} onClick={() => setProjectType('desktop')} className={`text-md md:text-lg font-bold uppercase hover:text-white CosiAzureFont
                 ${projectType === "desktop" ? 'text-white underline' : ' text-white/70'} underline-offset-8 transition-all duration-500`}>
                    {Lang === 'Ar' ? 'تطبيقات سطح المكتب' : (Lang === 'Fr' ? 'Application de Bureau' : 'Desktop')}
                    <span className='text-xs ml-2 inline-flex'>({data.filter(project => project.type === "desktop").length})</span>
                </motion.div>
            </div>
            <div className='py-10'>
                {data.filter(project => project.type === projectType).map((project, index) => (
                    <Project key={project.id} Lang={Lang} project={project} index={index} inView={inView} />
                ))}
            </div>
        </div>
    )
}
